import GridColumn from "@/classes/component-classes/GridColumn";

export default class Reports {

    constructor() {

        this.reportListGridColumns = [

            new GridColumn('3', 'Report Name', 'queryName', '201', true, false, ),
            new GridColumn('4', 'Description', 'description', '300', true, false),
            new GridColumn('5', 'Date From', 'dateFrom', '150', true, false),
            new GridColumn('5', 'Date To', 'dateTo', '150', true, false),
            new GridColumn('5', 'Search Criteria 1', 'param1', '200', true, false),
            new GridColumn('5', 'Search Criteria 2', 'param2', '200', true, false),
            new GridColumn('5', 'View Report', 'runReport', '60', true, false),

        ]

        this.reportListData =[];
        this.reportGridColumns = [];
        this.reportGridData = [];
        this.currentSelectedReport = '';

        this.reportTotalsGridColumns = [];
        this.reportTotalsGridData = [];

        this.currentPage = 1;
        this.currentPaginationRange = 1;

        this.currentTotalsPage = 1;
        this.currentTotalsPaginationRange = 1;
        this.hideExcelDownloadBusy = true;
        this.hideExcelDownloadBusyTotals = true;
    }
}